import React from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';

const CompanyProfile = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { labelKey: 'nav.aboutUs', href: '/#about-us' },
    { labelKey: 'aboutUs.companyProfile' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.companyProfile.title"
      subtitleKey="pages.companyProfile.subtitle"
      breadcrumbs={breadcrumbs}
    >
      <div className="content-card" style={{ textAlign: 'center' }}>
        <h2>{t('pages.companyProfile.overview.title')}</h2>
        <p>{t('pages.companyProfile.overview.description1')}</p>
        <p>{t('pages.companyProfile.overview.description2')}</p>

        {/* <div className="feature-box"> */}
        <h3>{t('pages.companyProfile.mission.title')}</h3>
        <p>{t('pages.companyProfile.mission.content')}</p>
        {/* </div> */}

        <h3>{t('pages.companyProfile.vision.title')}</h3>
        <p>{t('pages.companyProfile.vision.content')}</p>

        <h3>{t('pages.companyProfile.values.title')}</h3>
        <ul className="icon-list" style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
          <li><strong>{t('pages.companyProfile.values.item1.title')}</strong> - {t('pages.companyProfile.values.item1.desc')}</li>
          <li><strong>{t('pages.companyProfile.values.item2.title')}</strong> - {t('pages.companyProfile.values.item2.desc')}</li>
          <li><strong>{t('pages.companyProfile.values.item3.title')}</strong> - {t('pages.companyProfile.values.item3.desc')}</li>
          <li><strong>{t('pages.companyProfile.values.item4.title')}</strong> - {t('pages.companyProfile.values.item4.desc')}</li>
          <li><strong>{t('pages.companyProfile.values.item5.title')}</strong> - {t('pages.companyProfile.values.item5.desc')}</li>
        </ul>

        <h3>{t('pages.companyProfile.expertise.title')}</h3>
        <p>{t('pages.companyProfile.expertise.description')}</p>
        <ul className="icon-list" style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'inline-block' }}>
          <li>{t('pages.companyProfile.expertise.item1')}</li>
          <li>{t('pages.companyProfile.expertise.item2')}</li>
          <li>{t('pages.companyProfile.expertise.item3')}</li>
          <li>{t('pages.companyProfile.expertise.item4')}</li>
          <li>{t('pages.companyProfile.expertise.item5')}</li>

        </ul>

        <div className="stats-grid">
          <div className="stat-item">
            <span className="number">20+</span>
            <span className="label">{t('pages.companyProfile.stats.years')}</span>
          </div>
          <div className="stat-item">
            <span className="number">500+</span>
            <span className="label">{t('pages.companyProfile.stats.clients')}</span>
          </div>
          <div className="stat-item">
            <span className="number">15</span>
            <span className="label">{t('pages.companyProfile.stats.countries')}</span>
          </div>
          <div className="stat-item">
            <span className="number">98%</span>
            <span className="label">{t('pages.companyProfile.stats.satisfaction')}</span>
          </div>
        </div>

        <a href="/connect-us" className="page-action-button">
          {t('common.actions.contactUs')}
        </a>
      </div>
    </PageTemplate>
  );
};

export default CompanyProfile;
